import type { WMenuTranslations } from "./pl";

export const en: WMenuTranslations = {
  ariaLabelFallback: "Menu",
  empty: "No menu items.",
};
